import React, {Component} from 'react'
import {Modal, Form, Row, Col, Input, Button, Select} from 'antd'
import dataTargetAPI from '../../../apis/dataTarget'
import {withTranslation} from 'react-i18next'

class CopyModal extends Component {
  formRef = React.createRef()
  state = {
    customerList: []
  }

  componentDidMount = () => {
    dataTargetAPI.customerAction().then(res => {
      this.setState({
        customerList: res.data.data
      })
    })
  }

  handleOk = () => {
    const {handleCancel, handleSearch, id} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      let param = {
        targetName: fieldsValue.targetName,
        id,
        customer: fieldsValue.customer
      }
      dataTargetAPI.copyAction(param).then(res => {
        handleCancel('copyModalVisible')
        handleSearch()
      })
    }).catch(err => { })
  }

  render() {
    const {copyModalVisible, handleCancel, t} = this.props
    return (
      <>
        <Modal
          title={`${t(`general.copy`)} ${t(`dataTarget.dataTarget`)}`}
          closable={true}
          visible={copyModalVisible}
          onCancel={() => { handleCancel('copyModalVisible') }}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={() => { handleCancel('copyModalVisible') }}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row justify="start" gutter={[10, 0]}>
              <Col span={24}>
                <Form.Item name="targetName" label={t(`dataTarget.targetName`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`dataTarget.targetName`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="customer" label={t(`dataTarget.customer`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseSelect`)} ${t(`dataTarget.customer`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                    {
                      this.state.customerList.map((e, i) => {
                        return (
                          <Select.Option key={e.id} value={e.id}>{e.customer}</Select.Option>
                        )
                      })
                    }
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(CopyModal)
